import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { Company } from '@/types'
import type { UpdateBrandingSettingsRequest } from '@/types/api'
import { APP_NAME } from '@/utils/app-constants'

export interface BrandingState extends UpdateBrandingSettingsRequest {
  loaded: boolean
}

interface BrandingStore extends BrandingState {
  setBranding: (branding: Partial<BrandingState>) => void
  hydrateFromCompany: (company: Company | null | undefined) => void
  resetBranding: () => void
}

const defaultBranding: BrandingState = {
  platform_name: APP_NAME,
  logo_url: '',
  icon_url: '',
  primary_color: '#2563EB',
  secondary_color: '#0F172A',
  accent_color: '#14B8A6',
  loaded: false,
}

export const useBrandingStore = create<BrandingStore>()(
  persist(
    (set) => ({
      ...defaultBranding,
      setBranding: (branding) => set((state) => ({ ...state, ...branding, loaded: true })),
      hydrateFromCompany: (company) => {
        const settings = (company?.settings?.branding as Partial<BrandingState> | undefined) ?? undefined
        set((state) => ({
          ...state,
          ...defaultBranding,
          ...(settings ?? {}),
          loaded: true,
        }))
      },
      resetBranding: () => set(defaultBranding),
    }),
    {
      name: 'ising-branding',
      partialize: (state) => ({
        platform_name: state.platform_name,
        logo_url: state.logo_url,
        icon_url: state.icon_url,
        primary_color: state.primary_color,
        secondary_color: state.secondary_color,
        accent_color: state.accent_color,
        loaded: state.loaded,
      }),
    },
  ),
)
